import { useAuthStore } from '@/stores/auth.js'

/**
 * Директива v-can-write: убирает элемент, если роль не даёт права на изменение.
 *
 * Значение — id модуля (число или числовая строка) либо ключ раздела
 * администрирования (`products`, `users`, ... — App\Enums\AdminSections).
 * Без значения (или с пустым) id модуля берётся из параметра маршрута, который маршрут
 * объявил в `meta.moduleParam`. На маршрутах без такой метки `:id` — это id заказа,
 * накладной и т. п., а не модуля, поэтому гадать по нему нельзя: элемент остаётся,
 * запись режет бэкенд.
 *
 * Уровень доступа приходит с бэкенда в /me → access. Уровень `read` и отсутствие
 * доступа прячут элемент, `full` оставляет. Проверку записи бэкенд делает сам
 * (middleware module-access / section-access), директива только убирает кнопки.
 *
 * Пример: <button v-can-write="'products'">Добавить</button>
 */
function isAllowed(binding) {
  const auth = useAuthStore()

  let target = binding.value
  if (target === undefined || target === null || target === '') {
    // Страница модуля: id модуля лежит в параметре, названном в meta.moduleParam
    const route = binding.instance?.$route
    const param = route?.meta?.moduleParam
    target = param ? route?.params?.[param] : undefined
  }

  // Проверять нечего — элемент остаётся: молчаливое скрытие без цели опаснее лишней кнопки
  if (target === undefined || target === null || target === '') return true

  const value = String(target)

  return /^\d+$/.test(value)
    ? auth.canEditModule(Number(value))
    : auth.canEditSection(value)
}

export default {
  // created — элемент ещё не вставлен в DOM, скрытие здесь убирает мигание кнопки
  created(el, binding) {
    el.__canWrite = isAllowed(binding)
    if (el.__canWrite === false) {
      el.style.display = 'none'
    }
  },
  mounted(el) {
    if (el.__canWrite === false && el.parentNode) {
      el.parentNode.removeChild(el)
    }
  },
}
